/** Maps share-sheet UI choices → referral link audience scopes (web). */

export function audienceForShareChoice(mode, contactsOnlyLimit) {
  if (mode === "person") return "link_only";
  return contactsOnlyLimit ? "contacts_only" : "everyone";
}

export const SHARE_PREF_KEY = "referlinc_share_contacts_only";
